import { ButtonsGroup, IButtonItemProps } from "@evergis/ui";
import React, { FC } from "react";
import { AttributesHeader } from "../../../DialogComponents/Attributes/AttributesHeader";
import { AttributesTabs } from "../../../DialogComponents/Attributes/styled";

export type LayerAttributesHeaderProps = {
  attributesTypes?: IButtonItemProps[];
  selectedType?: IButtonItemProps;
  setSelectedType?: (option: IButtonItemProps) => void;
};

export const LayerAttributesHeader: FC<LayerAttributesHeaderProps> = ({
  selectedType,
  setSelectedType,
  attributesTypes,
}) => {
  return (
    <AttributesHeader showTitle>
      <AttributesTabs>
        <ButtonsGroup options={attributesTypes} selected={selectedType} onClick={setSelectedType} />
      </AttributesTabs>
    </AttributesHeader>
  );
};
